/** The KeyTurn Health dial: a 320° track with a 40° keyway gap at the base. */
export const TRACK_START = -160
export const TRACK_SWEEP = 320

/** 0° sits at twelve o'clock and angles run clockwise. */
export function polar(cx: number, cy: number, r: number, angle: number) {
  const rad = ((angle - 90) * Math.PI) / 180
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) }
}

export function describeArc(cx: number, cy: number, r: number, from: number, to: number) {
  if (Math.abs(to - from) < 0.4) return ''
  const start = polar(cx, cy, r, from)
  const end = polar(cx, cy, r, to)
  const largeArc = Math.abs(to - from) > 180 ? 1 : 0
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`
}

export function angleForScore(score: number) {
  const clamped = Math.max(0, Math.min(100, score))
  return TRACK_START + (clamped / 100) * TRACK_SWEEP
}
